import axios from 'axios';
import azureAd from '../config/azureAd';

const success = action => {
  return `${action}_SUCCESS`;
};

const error = action => {
  return `${action}_ERROR`;
};

const createAxiosAction = ({
  actionPayload,
  startAction,
  method,
  url,
  body,
}) => (dispatch, getState) => {
  dispatch({ ...actionPayload, type: startAction });

  let config = {
    method,
    data: body,
    url,
  };

  let action = azureAd.adalApiFetch(axios, url, config);

  return action
    .then(payload => {
      dispatch({
        ...actionPayload,
        type: success(startAction),
        payload: payload.data,
      });
      return payload;
    })
    .catch(payload => {
      dispatch({ ...actionPayload, type: error(startAction) });
      return Promise.reject(payload);
    });
};

export { createAxiosAction, error, success };
